export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10121.d7e31c91.jpg";